export const RANKS = [
    "A", "2", "3", "4", "5", "6", "7", "J", "Q", "K"
]

export const SUITS = ["O", "C", "E", "B"]

export const CARD_BACK_NOTATION = "XX"

export const RANK_MAP = {
    "A": 0,
    "2": 1,
    "3": 2,
    "4": 3,
    "5": 4,
    "6": 5,
    "7": 6,
    "J": 7,
    "Q": 8,
    "K": 9,
    "X": 10
}

export const SUIT_MAP = {
    O: 0,
    C: 1,
    E: 2,
    B: 3,
    X: 0
}

export const PHASE = {
    IDLE: "IDLE",
    MATCH_STARTING: "MATCH_STARTING",
    DEALING: "DEALING",
    PLAYING: "PLAYING",
    TRICK_RESULT: "TRICK_RESULT",
    MATCH_RESULT: "MATCH_RESULT",
    GAME_RESULT: "GAME_RESULT"
}

export const trucoPhase = {
    TRUCO: "TRUCO",
    RE_TRUCO: "RE_TRUCO",
    FOUR: "FOUR",
    ACCEPT_TRUCO: "ACCEPT_TRUCO",
    ACCEPT_RETRUCO: "ACCEPT_RETRUCO",
    ACCEPT_FOUR: "ACCEPT_FOUR",
    DONT_ACCEPT: "DONT_ACCEPT"
}